import { DataQualityAssessmentReadModel } from 'types/types';
import { isArraySingleEmptyValue } from 'util/utils';
import DataQualityAssessmentAndReferenceYearsGridPdf from '../../grids/data-quality-assessment-and-ref-years/DataQualityAssessmentAndReferenceYearsGridPdf';

const VersionHistoryDataQualityAssessmentGrid: React.FC<{
  dataQualityAssessmentAndReferenceYears: DataQualityAssessmentReadModel;
  className?: string;
}> = ({ dataQualityAssessmentAndReferenceYears, className }) => {
  // #11472. The users visually can't to figure out whether the empty row is added by default or they forgot to delete empty row, which was added by them before.
  // So it is needed to hide the table if the single entity with empty fields is existed.
  const isOnlySingleEmptyRow =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    isArraySingleEmptyValue(dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems);

  const anyRows =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems.length > 0 &&
    !isOnlySingleEmptyRow;

  const summaryExists =
    !!dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary &&
    (!!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ||
      !!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary.dataQualityAssessmentComment);

  if (!anyRows && !summaryExists) {
    return null;
  }

  return anyRows ? (
    <DataQualityAssessmentAndReferenceYearsGridPdf
      className={className}
      dataQualityAssessmentItems={dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems}
    />
  ) : null;
};

export default VersionHistoryDataQualityAssessmentGrid;
